import { NotInServiceScheduleEntry } from '../../../clients/quipli-service/availability/availability';
import './schedule-tooltip.scss';

export const NotInServiceScheduleTooltip = ({
  notInServiceScheduleEntry,
}: {
  notInServiceScheduleEntry: NotInServiceScheduleEntry;
}) => {
  return (
    <div className="not-in-service-tooltip">
      <div>
        <span className="tooltip-label">Not In Service</span>
      </div>
      <div>
        <span className="tooltip-label">In Service Date:</span> {notInServiceScheduleEntry.to.toFormat('D t')}
      </div>
    </div>
  );
};
